import { Card, PageContainer, Skeleton } from '@/components/ui'

export default function OrderPageLoading() {
  return (
    <PageContainer top="header-gap" bottom="chrome" className="flex flex-col gap-4" aria-busy>
      <div className="flex flex-col gap-2">
        <Skeleton className="h-6 w-1/2" />
        <Skeleton className="w-2/3" />
      </div>

      <Card padding="lg" className="flex flex-col gap-3">
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-2 w-full" />
        <Skeleton className="w-1/2" />
      </Card>

      <Card padding="lg" className="flex flex-col gap-4">
        <Skeleton className="h-6 w-1/2" />
        {[1, 2].map((index) => (
          <div key={index} className="flex gap-3">
            <Skeleton shape="block" className="h-16 w-16 shrink-0" />
            <div className="flex flex-1 flex-col gap-2">
              <Skeleton className="h-5 w-2/3" />
              <Skeleton className="h-3 w-1/2" />
            </div>
          </div>
        ))}
      </Card>

      <Card padding="lg" className="flex flex-col gap-3">
        <Skeleton className="h-6 w-1/2" />
        <Skeleton className="w-full" />
        <Skeleton className="w-full" />
        <Skeleton className="h-6 w-1/3" />
      </Card>

      <Card padding="lg" className="flex flex-col gap-2">
        <Skeleton className="h-6 w-1/2" />
        <Skeleton className="w-3/4" />
        <Skeleton className="w-1/2" />
      </Card>
    </PageContainer>
  )
}
